import React, { FC } from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faBars } from "@fortawesome/pro-solid-svg-icons/faBars";
import { faChartSimple } from "@fortawesome/pro-solid-svg-icons/faChartSimple";
import { faEquals } from "@fortawesome/pro-solid-svg-icons/faEquals";
import { faPen } from "@fortawesome/pro-solid-svg-icons/faPen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import PinLegendClassificationType from "@mapmycustomers/shared/enum/pinLegends/PinLegendClassificationType";

import getPinLegendClassificationDisplayName from "../../utils/getPinLegendClassificationDisplayName";

import Button from "./Button";
import styles from "./MethodField.module.scss";

const classificationIcon: Record<PinLegendClassificationType, IconProp | undefined> = {
  [PinLegendClassificationType.EQUAL_INTERVAL]: faEquals,
  [PinLegendClassificationType.MANUAL]: faPen,
  [PinLegendClassificationType.NATURAL_BREAKS]: faChartSimple,
  [PinLegendClassificationType.QUANTILE]: faBars,
  [PinLegendClassificationType.SIMPLE]: undefined,
};

export interface MethodFieldProps {
  classifications: PinLegendClassificationType[];
  onChange?: (classification: PinLegendClassificationType) => void;
  value: PinLegendClassificationType;
}

const MethodField: FC<MethodFieldProps> = ({ classifications, onChange, value }) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      {classifications.map((classification) => {
        const icon = classificationIcon[classification];
        return (
          <Button
            active={classification === value}
            icon={
              icon && (
                <FontAwesomeIcon
                  icon={icon}
                  rotation={
                    classification === PinLegendClassificationType.QUANTILE ? 90 : undefined
                  }
                />
              )
            }
            key={classification}
            onClick={onChange}
            title={getPinLegendClassificationDisplayName(intl, classification)}
            type={classification}
          />
        );
      })}
    </div>
  );
};

export default MethodField;
